/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import VaccinationScheduleDetails from './vaccination-schedule-details';
import VaccinationScheduleDetailsDetail from './vaccination-schedule-details-detail';
import VaccinationScheduleDetailsUpdate from './vaccination-schedule-details-update';
import VaccinationScheduleDetailsDeleteDialog from './vaccination-schedule-details-delete-dialog';

const VaccinationScheduleDetailsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<VaccinationScheduleDetails />} />
    <Route path="new" element={<VaccinationScheduleDetailsUpdate />} />
    <Route path=":id">
      <Route index element={<VaccinationScheduleDetailsDetail />} />
      <Route path="edit" element={<VaccinationScheduleDetailsUpdate />} />
      <Route path="delete" element={<VaccinationScheduleDetailsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default VaccinationScheduleDetailsRoutes;
